import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyList = createAsyncThunk("societyList", async ({ status, type, startDate, endDate }) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const response = await AxiosInstance.get(
      `${API_KEY}/api/society/filter`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...(status && { status }),
          ...(type && { type }),
          ...(startDate && endDate && { startDate, endDate })
        }
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  societyListData: null,
  isError: false,
  errorMessage: "",
};

const societyListSlice = createSlice({
  name: "societyList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyListData = action.payload;
    });
    builder.addCase(societyList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyListSlice.reducer;
